import React from 'react';
import shopItems from '../../../config/shop';
import PurchaseItem from './PurchaseItem';

const Coins = ({}) => {
    const coins = shopItems['coins'];
    return(
        <div className={`coins`}>
            { coins.map((coin, index) => 
                <PurchaseItem 
                    key={index} 
                    amount={coin.amount} 
                    price={coin.price} 
                    label={coin.label ? coin.label : ''}
                    tab="coins"
                />
            )}
        </div>
    )
}
export default Coins;